import type {components} from '@wallaby-ui/document/types/js/common/_generated/haidi_schema';

type RuleTooltip = components['schemas']['RuleTooltip'];

/**
 * The only rule tooltip with a placeholder: `enum.rule.tooltip.outpatientDiagnosis` says how many days after surgery
 * an outpatient SSI still counts, which is the hospital's `instance.ssi-period-days` (PDH-3247).
 */
const OUTPATIENT_DIAGNOSIS: RuleTooltip = 'OUTPATIENT_DIAGNOSIS';

/**
 * Before the period became configurable it was a fixed 30 days, and migration 0042 backfills every older HAI with it.
 * A HAI without the value can therefore only come from a backend older than PDH-3259, and 30 is the period it was
 * detected with.
 */
export const LEGACY_SSI_PERIOD_DAYS = 30;

export type TooltipTranslate = (messageKey: string, textParams?: Record<string, string | number>) => string;

/**
 * Translates a rule tooltip (PDH-3259). The outpatient SSI tooltip gets the period the HAI was created with
 * (`HAIDetailDto.ssiPeriodDays`) as `{days}`; every other tooltip is translated as it is, without parameters.
 */
export function translateHaiRuleTooltip(
  t: TooltipTranslate,
  messageKey: string,
  ruleTooltip: RuleTooltip,
  ssiPeriodDays: number | null | undefined
): string {
  if (ruleTooltip === OUTPATIENT_DIAGNOSIS) {
    return t(messageKey, {days: ssiPeriodDays ?? LEGACY_SSI_PERIOD_DAYS});
  }
  return t(messageKey);
}
